import React from "react";
import { ListGroup } from "react-bootstrap";
import Const from "const.json";
import ComparerIndicator from "../ComparerIndicator/ComparerIndicator";
import "./ListItemView.scss";
import { DetailsViewProps } from "types/ListAndDetailTypes";
import { useYearFromRedux } from "utils/utilsLogic";
import { numberWithCommas } from "utils/utils";
import useMediaQuery from "hooks/useMediaQuery";
import NoData from "components/ui/NoData";
import { MediaQuery } from "enums/enums";

const DetailsView: React.FC<DetailsViewProps> = ({ dataList, isComparedOnYear = false }) => {

  const isMobile = useMediaQuery(MediaQuery.Mobile)
  const { comparisonTextToLastYear, comparedOnYear } = useYearFromRedux();

  return (
    <div>
      <ListGroup className="details-list">
        <ListGroup.Item className="listGroupItem border-0">
          <span className="bold w-40" >{!isMobile ? dataList.header : dataList.header && `${dataList.header.split(' ')[0]} ${dataList.header.split(' ')[1]}`}</span>
          { !isMobile && <span className="bold w-40 d-flex justify-content-center" >{isComparedOnYear ? comparedOnYear : comparisonTextToLastYear}</span> }
        </ListGroup.Item>
        {dataList && dataList.rows && dataList.rows.length ? dataList.rows.map((item, index) => (
          <ListGroup.Item className="listGroupItem border-0" key={index}>
            <div className=" flex2 description">
              <div>{item.description}</div>
            </div>
            <div className="flex1 complaintsCount">
              <h5 className="bold"  >
                {numberWithCommas(item.complaintsCount || item.complaintsPercent)}{item.complaintsPercent ? '%' : ` ${Const.complaints}`}
              </h5>
            </div>
            { !isMobile &&
              <div className="flex2 pe-3  w-25 d-flex justify-content-center">
                <ComparerIndicator comparerData={item.comparerData} />
              </div>
            }
          </ListGroup.Item>
        ))
        :
        <NoData/>}
      </ListGroup>
    </div>
  );
};

export default DetailsView;
